import 'core-js/client/shim';
import 'zone.js';

if (process.env.ENV === 'build') {
    // Production
} else {
    // Development
    Error['stackTraceLimit'] = Infinity;
}
